"use client";

import { useState } from "react";
import Link from "next/link";
import { Menu, X } from "lucide-react";
import Image from "next/image";
import { usePathname } from "next/navigation";

const navLinks = [
  { name: "Domů", href: "/" },
  { name: "Blog", href: "#blog" },
  { name: "Moje práce", href: "#moje-prace" },
  { name: "Ceník", href: "#cenik" },
  { name: "Kontakt", href: "#kontakt" },
  { name: "Broušení nožů poštou", href: "/brouseni-nozu-postou" },
];

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const pathname = usePathname();

  // navLinks fixed (#kontakt → /#kontakt)
  const resolveHref = (href: string) => {
    if (href.startsWith("#")) {
      return pathname === "/" ? href : `/${href}`;
    }
    return href;
  };

  return (
    <header className="sticky top-0 z-50 bg-primary shadow-sm">
      <div className="container mx-auto flex items-center justify-between p-4">

        {/* Logo */}
        <Link href="/" className="flex items-center gap-4 group">
          <Image
            src="/logo.svg"
            alt="Broušení Lések"
            width={50}
            height={50}
            className="transition-transform duration-300 group-hover:rotate-12"
          />
          <div className="flex flex-col gap-y-0.5">
            <span className="text-xl font-bold text-gray-300 leading-none group-hover:tracking-wider transition-all duration-300">
              Jiří Lések
            </span>
            <h1 className="text-xm text-white uppercase leading-none tracking-[0.2em] font-semibold m-0 p-0">
              Broušení řezných nástrojů
            </h1>
          </div>
        </Link>

        {/* Desktop Navigace */}
        <nav className="hidden md:flex items-center space-x-6">
          {navLinks.map((link) => (
            <Link
              key={link.name}
              href={resolveHref(link.href)}
              className="relative text-white hover:text-secondary hover:underline font-medium transition-colors duration-200"
            >
              {link.name}

              {/* Badge */}
              {link.name === "Broušení nožů poštou" && (
                <span className="absolute -top-3.5 -right-0.5 bg-secondary text-primary px-3 py-0.3 text-[10px] rounded-full font-bold">
                  NOVÉ
                </span>
              )}
            </Link>
          ))}
        </nav>

        {/* Mobile menu button */}
        <div className="md:hidden">
          <button
            onClick={() => setIsOpen(!isOpen)}
            aria-label={isOpen ? "Zavřít menu" : "Otevřít menu"}
            className="p-2 text-white hover:text-secondary focus:outline-none focus:ring-2 focus:ring-white/30 rounded-md transition-all duration-200 relative"
          >
            <Menu
              className={`h-6 w-6 absolute transition-all duration-300 ${
                isOpen ? "opacity-0 rotate-90 scale-0" : "opacity-100 rotate-0 scale-100"
              }`}
            />
            <X
              className={`h-6 w-6 transition-all duration-300 ${
                isOpen ? "opacity-100 rotate-0 scale-100" : "opacity-0 -rotate-90 scale-0"
              }`}
            />
          </button>
        </div>
      </div>

      {/* Mobile Navigace */}
      {isOpen && (
        <div className="md:hidden bg-white shadow-lg py-2">
          <nav className="flex flex-col items-center space-y-4">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                href={resolveHref(link.href)}
                onClick={() => setIsOpen(false)}
                className="flex items-center justify-center gap-2 w-full py-2 text-gray-700 hover:bg-gray-100 font-medium transition-colors duration-200"
              >
                {link.name}

                {/* Badge NOVÉ */}
                {link.name === "Broušení nožů poštou" && (
                  <span className="bg-secondary text-primary px-2 py-[2px] text-[10px] rounded-full font-bold">
                    NOVÉ
                  </span>
                )}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
